import { useMemo } from 'react';
import RightColumnComp from 'developer-docs-shared-components/components/endpoint/RightColumnComp';
import { jsx as _jsx } from "react/jsx-runtime";
const EndpointRightColumn = ({
  children
}) => {
  const columnSpan = useMemo(() => ({
    base: 12,
    laptop: 6
  }), []);
  return /*#__PURE__*/_jsx(RightColumnComp, {
    columnSpan: columnSpan,
    children: children
  });
};
export default EndpointRightColumn;